<textarea placeholder="{{'Your comment...'|translate}}" [(ngModel)]="editorContent"></textarea>
<div class="button-right-div">
<button mat-stroked-button color="primary" class="button-right" (click)="postComment()" *ngIf="!editingComment">{{'Post'|translate}}</button>
<button mat-stroked-button (click)="cancelEdit()" class="button-right" *ngIf="editingComment">{{'Cancel'|translate}}</button>
<button mat-stroked-button color="primary" class="button-right" (click)="postComment()" *ngIf="editingComment">{{'Save'|translate}}</button>
</div>